import request from "../utils/request";
/**
 * code 返回 0 成功  401 toke失效  其他任何都是失败
 */
const requestApi = {
    // 登录
    login (data) {
        return request("/account/login", data);
    },
    // 登出
    logout (data) {
        return request("/account/logout", data, 'get');
    },
    // 查询字典 
    queryDist (data) {
        return request("/sysDict/queryDist", data, 'get');
    },
    // 查询字典 
    areaTree (data) {
        return request("/sysDict/area", data, 'get');
    },
    // 获取当前登录用户信息
    getUserInfo (data) {
        return request("/account/getUserInfo", data, 'get');
    },
    // 获取导航菜单tree
    getMenutree (data) {
        return request("/sysUser/queryMenuListByUserId", data, 'get');
    },
    // 获取日志管理列表 
    queryLogList (data) {
        return request("/sysLog/queryLogList", data, 'get');
    },
    // 获取角色管理列表 
    queryRoleList (data) {
        return request("/sysRole/queryRoleList", data, 'get');
    },
    // 新增角色 
    addRole (data) {
        return request("/sysRole/addRole", data);
    },
    // 编辑、修改角色信息 
    updateRole (data) {
        return request("/sysRole/updateRole", data);
    },
    // 删除当前角色 
    deleteRole (data) {
        return request("/sysRole/deleteRole", data, 'get');
    },
    // 查询角色权限
    queryRoleMenuPerm (data) {
        return request("/sysRole/queryRoleMenuPerm", data, 'get');
    },
    // 分配角色权限
    roleMenuPerm (data) {
        return request("/sysRole/roleMenuPerm", data);
    },
    // 获取用户管理列表
    queryUserList (data) {
        return request("/sysUser/queryUserList", data, 'get');
    },
    // 新增用户 
    addUser (data) {
        return request("/sysUser/addUser", data);
    },
    // 查看详情 
    queryUser (data) {
        return request("/sysUser/queryUser", data, 'get');
    },
    // 编辑用户 
    updateUser (data) {
        return request("/sysUser/updateUser", data);
    },
    // 删除用户 
    deleteUsers (data) {
        return request("/sysUser/deleteUsers", data, 'get');
    },
    // 获取工单列表
    queryWorkOrderList (data) {
        return request("/workOrder/queryWorkOrderList", data, 'get');
    },
    // 新增工单
    addWorkOrder (data) {
        return request("/workOrder/process/addWorkOrder", data);
    },

    // 修改工单
    updateWorkOrder (data) {
        return request("/workOrder/process/updateWorkOrder", data);
    },
    // 查询部门列表（审核人员列表）
    queryLeaderList (data) {
        return request("/workOrder/queryLeaderList", data, 'get');
    },
    // 查询自己各个状态的工单数量
    queryWorkOrderCount (data) {
        return request("/workOrder/queryWorkOrderCount", data, 'get');
    },
    // 审核工单 -通过/驳回两种状态 
    auditWorkOrder (data) {
        return request("/workOrder/process/auditWorkOrder", data);
    },
    // 指派工单
    pointWorkOrder (data) {
        return request("/workOrder/process/pointWorkOrder", data);
    },
    // 工单日志
    queryWorkOrderProcess (data) {
        return request("/workOrder/queryWorkOrderProcess", data, 'get');
    },
    // 返还工单
    backWorkOrder (data) {
        return request("/workOrder/process/backWorkOrder", data);
    },
    // 上传接口
    uploadFile (data) {
        return request("/sysFile/uploadFile", data);
    },
    // 凭证提交
    confirmPic (data) {
        return request("/workOrder/confirmPic", data);
    },
    // 分页查询文件
    selectFile (data) {
        return request("/sysFile/selectFile", data, 'get');
    },
    // 通用上传 
    commonUploadFile (data) {
        return request("/sysFile/commonUploadFile", data);
    },
    // 确认工单
    confirmWorkOrder (data) {
        return request("/workOrder/process/confirmWorkOrder", data);
    },
    // 意见反馈列表
    queryAdviceList (data) {
        return request("/advice/queryAdviceList", data, 'get');
    },
    // 指派意见
    pointAdvice (data) {
        return request("/advice/pointAdvice", data);
    },
    // 处理意见  
    processAdvice (data) {
        return request("/advice/processAdvice", data);
    },
    // 确认意见
    confirmAdvice (data) {
        return request("/advice/confirmAdvice", data);
    },
    // 审核用户
    auditAccount (data) {
        return request("/account/auditAccount", data, 'get');
    },
    // 消息通知
    queryNotifyList (data) {
        return request("/workOrder/queryNotifyList", data, 'get');
    },
    // 消息通知详情
    jumpToWorkOrderById (data) {
        return request(`/workOrder/jumpToWorkOrderById`, data, 'get');
    },
    // 消息通知详情
    jumpToWorkOrderById (data) {
        return request(`/workOrder/jumpToWorkOrderById`, data, 'get');
    },
    // 查询企业列表
    queryOrgList (data) {
        return request(`/org/queryOrgList`, data, 'get');
    },
    // 新增企业
    addOrg (data) {
        return request(`/org/addOrg`, data, 'post');
    },
    // 修改企业
    updateOrg (data) {
        return request(`/org/updateOrg`, data, 'post');
    },
    // 删除企业
    delOrg (data) {
        return request(`/org/delOrg`, data, 'get');
    },
}
export default requestApi;


// WEBPACK FOOTER //
// ./src/api/requestApi.js